import { Coins, Bitcoin, Shield, Layers, Rocket, Globe, Ghost, Gift } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface Category {
  id: string;
  name: string;
  description: string;
  icon: LucideIcon;
  tag: string;
}

export const CATEGORIES: Category[] = [
  {
    id: 'geld',
    name: 'Was ist Geld',
    description: 'Grundlagen des Geldsystems und warum Bitcoin wichtig ist',
    icon: Coins,
    tag: 'geld',
  },
  {
    id: 'grundlagen',
    name: 'Bitcoin Grundlagen',
    description: 'Die Basics: Wie funktioniert Bitcoin?',
    icon: Bitcoin,
    tag: 'grundlagen',
  },
  {
    id: 'sicherheit',
    name: 'Sicherheit und Wallets',
    description: 'Schütze deine Bitcoin richtig',
    icon: Shield,
    tag: 'sicherheit',
  },
  {
    id: 'layer2',
    name: 'Second Layer',
    description: 'Lightning Network und Skalierung',
    icon: Layers,
    tag: 'layer2',
  },
  {
    id: 'praxis',
    name: 'Praxis & Einsteiger-Guides',
    description: 'Schritt-für-Schritt Anleitungen für den Alltag',
    icon: Rocket,
    tag: 'praxis',
  },
  {
    id: 'zukunft',
    name: 'Dezentralität und Zukunft',
    description: 'Bitcoin, Nostr, Linux und freie Technologien',
    icon: Globe,
    tag: 'zukunft',
  },
  {
    id: 'mythen',
    name: 'Mythen und Verschwörungen',
    description: 'Häufige Irrtümer und Falschinformationen über Bitcoin',
    icon: Ghost,
    tag: 'mythen',
  },
  {
    id: 'empfehlungen',
    name: 'Empfehlungen',
    description: 'Produkt-Tipps und Rabattcodes',
    icon: Gift,
    tag: 'empfehlungen',
  },
];

export const getCategoryById = (id: string): Category | undefined => {
  return CATEGORIES.find((cat) => cat.id === id);
};

export const getCategoryByTag = (tag: string): Category | undefined => {
  return CATEGORIES.find((cat) => cat.tag === tag);
};

// Site-wide tag for filtering content specific to this Bitcoin education site
export const SITE_TAG = 'wtfisbitcoin';

// Author pubkey - only articles from this author will be displayed
// Replace this with your actual Nostr pubkey
export const AUTHOR_PUBKEY = 'bc8e63437396c3e0a0e9a70995d2aebfaca1acd907f0c73a0857c60f5dfd3f29';
